import { useIsMobile } from "@/common/hooks/use-mobile";
import { AuthenticationProvider } from "@/common/providers/authentication";
import CopyIcon from "@/common/svgs/copy";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

function InformationAndReferrals() {
	const information = AuthenticationProvider.user!;
	const initials = information?.fullName
		.split(" ")
		.map((word) => word[0]?.toUpperCase())
		.join("");
	const isMobile = useIsMobile();

	const baseURL = import.meta.env.VITE_SERVER_API_URL;

	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-row items-center gap-8">
				<Avatar
					style={{
						height: 100,
						width: 100,
					}}
				>
					<AvatarImage
						src={`${baseURL}/common/profile-picture/${information?.profilePictureUrl}`}
					/>
					<AvatarFallback>{initials}</AvatarFallback>
				</Avatar>
				<div>
					<p className="web-heading-h4">{information?.fullName}</p>
					<p className="web-body-b1 text-gray-700">{information.email}</p>
				</div>
			</div>

			<div
				className="relative flex flex-col gap-4 rounded-[24px] p-6"
				style={{
					background:
						"radial-gradient(171.4% 138.54% at 80.57% 8.23%, rgba(46, 219, 202, 0.30) 18.51%, rgba(8, 50, 46, 0.00) 100%), linear-gradient(180deg, #004096 -29.98%, #470096 122.31%)",
					backgroundBlendMode: "plus-lighter, normal",
				}}
			>
				<img
					src={"/icons/gift.png"}
					width={"64"}
					height={74}
					style={{
						position: "absolute",
						top: -37,
						left: isMobile ? undefined : "50%",
						right: isMobile ? 0 : undefined,
						transform: "translateX(-50%)",
					}}
				/>

				<div className="flex flex-col gap-2">
					<p className="web-body-b2 text-white">Get Rewards for Referrals</p>
					<div className="flex flex-col gap-3 md:flex-row">
						<p className="web-body-b1 text-white-80">
							Share your link and get exclusive discounts on your membership.
						</p>
						<p className="web-body-b1 text-white underline">More info</p>
					</div>
				</div>
				<div className="flex flex-row justify-between rounded-[32px] bg-white p-4">
					<p className="web-body-b1">Coming Soon</p>
					<CopyIcon />
				</div>
			</div>
		</div>
	);
}

export default InformationAndReferrals;
